import React from "react"
import ReactDOM from 'react-dom/client';
import App from "./App"
import * as serviceWorker from "./serviceWorker"
import { BrowserRouter } from "react-router-dom"
import "./i18n"
import { Provider } from "react-redux"
import { Toaster } from 'react-hot-toast';
import { GoogleOAuthProvider } from '@react-oauth/google';

import store from "./store"

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
    <Provider store={store}>
      <>
        <BrowserRouter basename={process.env.PUBLIC_URL}>
          <Toaster toastOptions={{ duration: 6000 }} />
          <App />
        </BrowserRouter>
      </>
    </Provider>
  </GoogleOAuthProvider>,
);

serviceWorker.unregister()
